import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';
import { useCountry } from '../../../context/CountryContext';

export default function Theatres() {
  const { t } = useTranslation();
  const { countries, setCountry } = useCountry();
  const navigate = useNavigate();
  // The '' entry is "All Countries" - not a real theater, shown separately below.
  const realCountries = countries.filter((c) => c.code);

  const goToTheater = (code) => {
    setCountry(code);
    navigate('/Showtimes');
  };

  return (
    <InfoPage
      eyebrow={t('info.moviesEyebrow')}
      title={t('theatres.title')}
      subtitle={t('theatres.subtitle', { count: realCountries.length })}
      wide
    >
      <div className="info-grid">
        {realCountries.map((c) => (
          <button
            key={c.code}
            className="info-card"
            style={{ cursor: 'pointer', textAlign: 'left', width: '100%', border: 'none', font: 'inherit', color: 'inherit' }}
            onClick={() => goToTheater(c.code)}
          >
            <h3>{c.flag} {c.label}</h3>
            <p>{t('theatres.seeShowtimesAt', { label: c.label })}</p>
          </button>
        ))}
      </div>
    </InfoPage>
  );
}
